export default "__VITE_ASSET__BvIZM4lM__"